<ng-container *ngIf="salesOrder; else loadingTemplate">
  <div
    style="width: 100%; margin-bottom: 8px"
    fxLayout="column"
    fxLayoutAlign="start start"
  >
    <!-- Action Row -->
    <div
      style="width: 100%; margin-bottom: 8px"
      fxLayout="row"
      fxLayoutAlign="start start"
    >
      <mat-card style="width: 100%">
        <mat-card-content>
          <div
            style="width: 100%"
            fxLayout="row"
            fxLayoutAlign="space-between center"
          >
            <div style="display: flex;flex-direction: row;justify-content: center;align-items: center;gap: 16px;">
              <div *ngIf="salesOrder.isExternalOrder">
                <img style="height: 32px;" src="/assets/images/Window_World_Logo.jpg" />
              </div>
              <div class="page-title">{{ salesOrder.title }}</div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="8px">
              <button mat-raised-button color="primary" (click)="refresh()">
                Reload
              </button>
              <button
                *ngIf="salesOrder.canConvertToQuote"
                mat-raised-button
                color="primary"
                (click)="convertToQuote()"
              >
                Convert to Quote
              </button>
              <button
                *ngIf="salesOrder.canCreateNewDraft"
                mat-raised-button
                color="primary"
                (click)="createNewDraftVersion()"
              >
                Create New Version in Draft
              </button>
              <button
                *ngIf="salesOrder.canCopyToNewDraft"
                mat-raised-button
                color="primary"
                (click)="copyLinesToNewDraft()"
              >
                Copy Lines to New Draft Order
              </button>
              <button
                *ngIf="salesOrder.canCreateSysproOrder"
                mat-raised-button
                color="primary"
                (click)="createSysproOrder()"
              >
                Create SYSPRO Order
              </button>
              <button
                *ngIf="salesOrder.canCancelOrder"
                mat-raised-button
                color="warn"
                (click)="cancelOrderDialog()"
              >
                Cancel
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Header Cards Row -->
    <div
      style="width: 100%"
      fxLayout="row"
      fxLayoutAlign="start start"
      fxLayoutGap="8px"
    >
      <!-- General Details -->
      <mat-card fxFlex="25%" style="align-self: stretch">
        <mat-card-content>
          <mat-card-subtitle>
            <div class="card-title-container">
              <div>General Details</div>
              <div>
                <button
                  *ngIf="
                    salesOrder.canChangeSalesperson ||
                    salesOrder.canUseCashCustomer ||
                    salesOrder.canSearchExsistingCustomer ||
                    salesOrder.canCreateNewCustomer ||
                    salesOrder.canEditSysproCustomer
                  "
                  mat-icon-button
                  [matMenuTriggerFor]="menuGeneral"
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menuGeneral="matMenu">
                  <button
                    *ngIf="salesOrder.canChangeSalesperson"
                    mat-menu-item
                    (click)="editSalesPersonDetails()"
                  >
                    <mat-icon>support_agent</mat-icon>
                    <span>Change Salesperson</span>
                  </button>
                  <button
                    *ngIf="salesOrder.canUseCashCustomer"
                    (click)="useCashCustomer()"
                    mat-menu-item
                  >
                    <mat-icon>attach_money</mat-icon>
                    <span>Use Cash Customer</span>
                  </button>
                  <button
                    *ngIf="salesOrder.canSearchExsistingCustomer"
                    (click)="searchCustomer()"
                    mat-menu-item
                  >
                    <mat-icon>search</mat-icon>
                    <span>Search Existing Customer</span>
                  </button>
                  <button
                    *ngIf="salesOrder.canCreateNewCustomer"
                    (click)="createSysproCustomer()"
                    mat-menu-item
                  >
                    <mat-icon>person_add</mat-icon>
                    <span>Create SYSPRO Customer</span>
                  </button>
                  <button
                    *ngIf="salesOrder.canEditSysproCustomer"
                    (click)="editSysproCustomer()"
                    mat-menu-item
                  >
                    <mat-icon>manage_accounts</mat-icon>
                    <span>Edit SYSPRO Customer</span>
                  </button>
                </mat-menu>
              </div>
            </div>
          </mat-card-subtitle>
          <div>
            <table>
              <tr>
                <th class="th-label">Order Type</th>
                <td class="td-value">
                  <ng-container *ngIf="mode === 'SYSPRO'; else quoteType">
                    {{ salesOrder.orderType }}
                  </ng-container>
                  <ng-template #quoteType>
                    {{ salesOrder.orderType }} - {{ salesOrder.orderStatus }}
                  </ng-template>
                </td>
              </tr>
              <tr *ngIf="mode !== 'SYSPRO'">
                <th class="th-label">Quote Status</th>
                <td class="td-value">
                  {{ salesOrder.quoteBookStatusDesc }}
                </td>
              </tr>
              <tr>
                <th class="th-label">POS Reference</th>
                <ng-container
                  *ngIf="mode === 'POS'; else sysproReferenceTemplate"
                >
                  <td class="td-value">
                    <span *ngIf="salesOrder.orderReference"
                      >{{ salesOrder.orderReference }}.{{
                        salesOrder.orderVersion
                      }}</span
                    >
                  </td>
                </ng-container>
                <ng-template #sysproReferenceTemplate>
                  <td class="td-value">
                    <a
                      *ngIf="salesOrder.salesOrderHeaderId"
                      [routerLink]="[
                        '/pos/orders/' + salesOrder.salesOrderHeaderId
                      ]"
                      >{{ salesOrder.orderReference }}.{{
                        salesOrder.orderVersion
                      }}</a
                    >
                  </td>
                </ng-template>
              </tr>
              <tr>
                <th class="th-label">SYSPRO Order</th>
                <td class="td-value">
                  <a
                    *ngIf="salesOrder.erpSalesOrderNumber"
                    [routerLink]="[
                      '/pos/orders/syspro/' + salesOrder.erpSalesOrderNumber
                    ]"
                    >{{ salesOrder.erpSalesOrderNumber }}</a
                  >
                </td>
              </tr>
              <tr>
                <th class="th-label">Store</th>
                <td class="td-value">{{ salesOrder.storeName }}</td>
              </tr>
              <tr>
                <th class="th-label">Salesperson</th>
                <td class="td-value">{{ salesOrder.salesperson }}</td>
              </tr>
              <tr>
                <th class="th-label">Customer</th>
                <td class="td-value">{{ salesOrder.customerCode }}</td>
              </tr>
              <tr>
                <th class="th-label">Currency</th>
                <td class="td-value">{{ salesOrder.currencyName }}</td>
              </tr>
              <!-- <tr>
                  <th class="th-label">Order Date</th>
                  <td class="td-value">{{salesOrder.orderDate | date:'medium'}}</td>
                </tr>
                <tr>
                  <th class="th-label">Ship Date</th>
                  <td class="td-value">{{salesOrder.shipDate | date:'medium'}}</td>
                </tr>
                <tr>
                  <th class="th-label">Expiry Date</th>
                  <td class="td-value">{{salesOrder.expiryDate | date:'medium'}}</td>
                </tr> -->
            </table>
          </div>
        </mat-card-content>
        <mat-card-footer>
          <!-- <div class="card-footer-container">
              <button mat-raised-button color="primary" (click)="editHeaderDetails()">Edit</button>
            </div> -->
        </mat-card-footer>
      </mat-card>

      <!-- Order Customer Details -->
      <mat-card
        fxFlex="50%"
        style="align-self: stretch; margin: 0px 8px 0px 8px"
      >
        <mat-card-content>
          <div
            style="width: 100%"
            fxLayout="row"
            fxLayoutAlign="start start"
            fxLayoutGap="16px"
          >
            <div fxFlex="50%">
              <mat-card-subtitle>
                <div class="card-title-container">
                  <ng-container
                    *ngIf="showOrderDetails; else customerDetailsTitle"
                  >
                    <div>Order Details</div>
                  </ng-container>
                  <ng-template #customerDetailsTitle>
                    <div>Customer Details</div>
                  </ng-template>

                  <div>

                  </div>

                  <div style="display: flex;flex-direction: row;align-items: center;justify-content: center;gap: 16px;">
                    <div>
                      <mat-icon style="color: #632663;" *ngIf="salesOrder.canViewTfgVoucher">redeem</mat-icon>
                    </div>
                    <div  style="margin-top: 12px;"
                      *ngIf="
                        salesOrder.canViewTfgAccount ||
                        salesOrder.canViewTfgRewardsAccount
                      "
                    >
                      <img class="tfg-logo" src="/assets/images/tfg_small.jpg" />
                    </div>
                    <div>
                      <mat-slide-toggle
                        (change)="detailToggleChange($event)"
                      ></mat-slide-toggle>
                    </div>
                  </div>
                </div>
              </mat-card-subtitle>
              <div>
                <table>
                  <ng-container *ngIf="showOrderDetails; else customerDetails">
                    <tr>
                      <th class="th-label" style="min-width: 90px">
                        Truck Code
                      </th>
                      <td class="td-value">
                        {{ salesOrder.alternateKeyDisplayValue }}
                      </td>
                    </tr>
                    <tr>
                      <th class="th-label">Cust. PO #</th>
                      <td class="td-value">
                        {{ salesOrder.customerPoNumber }}
                      </td>
                    </tr>
                    <tr>
                      <th class="th-label">Ship. Instrs</th>
                      <td class="td-value">{{ salesOrder.shippingInstrs }}</td>
                    </tr>
                    <tr>
                      <th class="th-label">Special Instrs</th>
                      <td class="td-value">{{ salesOrder.specialInstrs }}</td>
                    </tr>
                    <!-- <tr>
                      <th class="th-label">Earliest. Ship Date</th>
                      <td class="td-value">
                        {{ salesOrder.earliestShipDate | date : "yyyy-MM-dd" }}
                      </td>
                    </tr> -->
                    <tr>
                      <th class="th-label">Req. Ship Date</th>
                      <td class="td-value">
                        {{ salesOrder.requestedShipDate | date : "yyyy-MM-dd" }}
                      </td>
                    </tr>
                    <tr>
                      <th class="th-label">Delayed Del. Date</th>
                      <td class="td-value">
                        {{
                          salesOrder.delayedDeliveryDat | date : "yyyy-MM-dd"
                        }}
                      </td>
                    </tr>
                  </ng-container>

                  <ng-template #customerDetails>
                    <tr>
                      <th class="th-label" style="min-width: 90px">Name</th>
                      <td class="td-value">{{ salesOrder.customerName }}</td>
                    </tr>
                    <tr>
                      <th class="th-label">Tax Number</th>
                      <td class="td-value">
                        {{ salesOrder.companyTaxNumber }}
                      </td>
                    </tr>
                    <tr>
                      <th class="th-label">Telephone</th>
                      <td class="td-value">{{ salesOrder.telephone }}</td>
                    </tr>
                    <tr>
                      <th class="th-label">Add. Tel.</th>
                      <td class="td-value">{{ salesOrder.addTelephone }}</td>
                    </tr>
                    <tr>
                      <th class="th-label">Email</th>
                      <td class="td-value">{{ salesOrder.email }}</td>
                    </tr>
                    <tr>
                      <th class="th-label">On Hold</th>
                      <td class="td-value">{{ salesOrder.customerOnHold }}</td>
                    </tr>
                    <!-- <tr>
                      <th class="th-label">Account Bal.</th>
                      <td class="td-value">{{salesOrder.customerAccountBalance | number:'1.0-0'}}</td>
                    </tr> -->
                  </ng-template>
                </table>
              </div>
            </div>

            <div fxFlex="50%">
              <mat-card-subtitle>
                <div class="card-title-container">
                  <div>Delivery Address</div>
                  <div>
                    <button
                      *ngIf="
                        salesOrder.canEditSalesOrderCustomer ||
                        salesOrder.canAddTfgAccount ||
                        salesOrder.canViewTfgAccount ||
                        salesOrder.canViewTfgRewardsAccount ||
                        salesOrder.canLinkTfgVoucher ||
                        salesOrder.canViewTfgVoucher
                      "
                      mat-icon-button
                      [matMenuTriggerFor]="menuCustomer"
                      aria-label="Example icon-button with a menu"
                    >
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menuCustomer="matMenu">
                      <button
                        *ngIf="salesOrder.canEditSalesOrderCustomer"
                        mat-menu-item
                        (click)="editCustomerDetails()"
                      >
                        <mat-icon>edit</mat-icon>
                        <span>Edit Customer Details</span>
                      </button>
                      <button
                        *ngIf="salesOrder.canEditSalesOrderDetails"
                        mat-menu-item
                        (click)="editOrderDetails()"
                      >
                        <mat-icon>edit</mat-icon>
                        <span>Edit Order Details</span>
                      </button>
                      <button
                        *ngIf="salesOrder.canEditSalesOrderCustomer"
                        mat-menu-item
                        (click)="refreshCustomerDetailsFromSyspro()"
                      >
                        <mat-icon>sync</mat-icon>
                        <span>Refresh from SYSPRO</span>
                      </button>
                      <button
                        *ngIf="salesOrder.canAddTfgAccount"
                        mat-menu-item
                        (click)="linkTfgAccount()"
                      >
                        <mat-icon>person_add</mat-icon>
                        <span>Link TFG Credit Account</span>
                      </button>
                      <button
                        *ngIf="salesOrder.canAddTfgAccount"
                        mat-menu-item
                        (click)="linkTfgRewardsAccount()"
                      >
                        <mat-icon>person_add</mat-icon>
                        <span>Link TFG Rewards Account</span>
                      </button>
                      <button
                        *ngIf="salesOrder.canViewTfgAccount"
                        mat-menu-item
                        (click)="viewTfgAccount()"
                      >
                        <mat-icon>person_search</mat-icon>
                        <span>View TFG Credit Account</span>
                      </button>
                      <button
                        *ngIf="salesOrder.canViewTfgRewardsAccount"
                        mat-menu-item
                        (click)="viewTfgRewardsAccount()"
                      >
                        <mat-icon>person_search</mat-icon>
                        <span>View TFG Rewards Account</span>
                      </button>
                      <button
                       *ngIf="salesOrder.canLinkTfgVoucher"
                        mat-menu-item
                        (click)="linkTfgVoucher()"
                      >
                        <mat-icon>redeem</mat-icon>
                        <span>Check TFG Voucher</span>
                      </button>
                      <button
                        *ngIf="salesOrder.canViewTfgVoucher"
                        mat-menu-item
                        (click)="viewTfgVoucher(salesOrder.canRemoveTfgVoucher || false)"
                      >
                        <mat-icon>redeem</mat-icon>
                        <span>View TFG Voucher</span>
                      </button>
                    </mat-menu>
                  </div>
                </div>
              </mat-card-subtitle>
              <div>
                <table>
                  <tr>
                    <th class="th-label" style="min-width: 90px">Building</th>
                    <td class="td-value">{{ salesOrder.shipToAddr1 }}</td>
                  </tr>
                  <tr>
                    <th class="th-label">Str/Unit Nr</th>
                    <td class="td-value">{{ salesOrder.shipToAddr2 }}</td>
                  </tr>
                  <tr>
                    <th class="th-label">Street Name</th>
                    <td class="td-value">{{ salesOrder.shipToAddr3 }}</td>
                  </tr>
                  <tr>
                    <th class="th-label">Suburb / City</th>
                    <td class="td-value">{{ salesOrder.shipToAddr4 }}</td>
                  </tr>
                  <tr>
                    <th class="th-label">Province</th>
                    <td class="td-value">{{ salesOrder.shipToAddr5 }}</td>
                  </tr>
                  <tr>
                    <th class="th-label">Postal Code</th>
                    <td class="td-value">{{ salesOrder.shipPostalCode }}</td>
                  </tr>
                  <tr>
                    <th class="th-label">Lat / Long</th>
                    <td class="td-value">
                      {{ salesOrder.shipToGpsLat }} /
                      {{ salesOrder.shipToGpsLong }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </mat-card-content>
        <mat-card-footer> </mat-card-footer>
      </mat-card>

      <!-- Financial Overview -->
      <mat-card
        fxFlex="25%"
        style="align-self: stretch"
        [ngStyle]="{
          'background-color':
            salesOrder?.financeSummary?.hasIntegrationError === true
              ? '#ffcbc2'
              : '#ffffff'
        }"
      >
        <mat-card-content>
          <mat-card-subtitle>
            <div class="card-title-container">
              <div>Financial Overview / Dates</div>
              <!-- <div><mat-icon matTooltip="One or more errors occured during payment integration, please contact support." color="warn">error</mat-icon></div> -->
            </div>
          </mat-card-subtitle>
          <div>
            <table
              *ngIf="salesOrder && salesOrder.financeSummary"
              style="width: 100%"
            >
              <tr *ngFor="let line of salesOrder.financeSummary.lines">
                <th class="th-label">{{ line.rowLabel }}</th>
                <td
                  class="td-value"
                  style="text-align: right"
                  [ngClass]="{
                    'os-warning-text': line.rowIndicateError === true
                  }"
                >
                  {{ line.rowValue }}
                </td>
              </tr>
            </table>
          </div>
        </mat-card-content>
        <mat-card-footer>
          <!-- <div class="card-footer-container">
              <button mat-raised-button color="primary" (click)="editHeaderDetails()">Edit</button>
            </div> -->
        </mat-card-footer>
      </mat-card>
    </div>

    <!-- Lines Row -->
    <div style="width: 100%; margin: 8px 0px 0px 0px">
      <mat-card>
        <mat-card-content>
          <mat-card-subtitle>
            <div class="card-title-container">
              <div>Line Details</div>
              <div>
                <button mat-icon-button (click)="refresh()">
                  <mat-icon>refresh</mat-icon>
                </button>
              </div>
            </div>
          </mat-card-subtitle>
          <div style="width: 100%">
            <kendo-grid
              [kendoGridBinding]="salesOrder.lines"
              [scrollable]="true"
              [resizable]="true"
              [reorderable]="true"
              [sortable]="true"
            >
              <kendo-grid-column
                [locked]="true"
                [width]="30"
                title=""
                class="td-action"
              >
                <ng-template
                  kendoGridCellTemplate
                  let-dataItem
                  let-rowIndex="rowIndex"
                >
                  <button
                    *ngIf="
                      dataItem.canEditLine ||
                      dataItem.canModifyDiscount ||
                      dataItem.canAddCoriguard ||
                      dataItem.canRemoveCoriguard ||
                      dataItem.canDeleteDeliveryFee ||
                      dataItem.canDeleteMiscCharge ||
                      dataItem.canModifyDiscount ||
                      dataItem.comments ||
                      dataItem.canViewDetails ||
                      dataItem.canAddExternalItem ||
                      dataItem.canEditNonStockLine
                    "
                    mat-icon-button
                    [matMenuTriggerFor]="rowMenu"
                    aria-label="Example icon-button with a menu"
                  >
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #rowMenu="matMenu">
                    <button
                      *ngIf="dataItem.canEditLine"
                      mat-menu-item
                      (click)="editLine(dataItem)"
                    >
                      <mat-icon>edit</mat-icon>
                      <span>Edit Warehouse / Qty</span>
                    </button>
                    <button
                      *ngIf="dataItem.canModifyDiscount"
                      mat-menu-item
                      (click)="modifyLineDiscount(dataItem)"
                    >
                      <mat-icon>sell</mat-icon>
                      <span>Edit Price / Discount</span>
                    </button>
                    <button
                      *ngIf="dataItem.canEditLine"
                      mat-menu-item
                      (click)="deleteLine(dataItem)"
                    >
                      <mat-icon>delete</mat-icon>
                      <span>Delete Line</span>
                    </button>
                    <button
                      *ngIf="dataItem.canCopyLine"
                      mat-menu-item
                      (click)="copyLine(dataItem)"
                    >
                      <mat-icon>content_copy</mat-icon>
                      <span>Copy Line</span>
                    </button>
                    <button
                      *ngIf="dataItem.canAddCoriguard"
                      mat-menu-item
                      (click)="addCoriguard(dataItem)"
                    >
                      <mat-icon>add_moderator</mat-icon>
                      <span>Add Coriguard</span>
                    </button>
                    <button
                      *ngIf="dataItem.canRemoveCoriguard"
                      mat-menu-item
                      (click)="removeCoriguard(dataItem)"
                    >
                      <mat-icon>remove_moderator</mat-icon>
                      <span>Remove Coriguard</span>
                    </button>
                    <button
                      *ngIf="dataItem.canDeleteDeliveryFee"
                      mat-menu-item
                      (click)="deleteDeliveryFee(dataItem)"
                    >
                      <mat-icon>delete</mat-icon>
                      <span>Delete Line</span>
                    </button>
                    <button
                      *ngIf="dataItem.canDeleteMiscCharge"
                      mat-menu-item
                      (click)="deleteMiscCharge(dataItem)"
                    >
                      <mat-icon>delete</mat-icon>
                      <span>Delete Line</span>
                    </button>
                    <button
                      *ngIf="dataItem.comments"
                      mat-menu-item
                      (click)="showComments(dataItem.comments)"
                    >
                      <mat-icon>comments</mat-icon>
                      <span>Show Comments</span>
                    </button>
                    <button
                      *ngIf="dataItem.canViewDetails && !dataItem.isNonStockLine"
                      mat-menu-item
                      (click)="viewDetails(dataItem)"
                    >
                      <mat-icon>info</mat-icon>
                      <span>View Details</span>
                    </button>

                    <!-- Non Stock Lines -->
                    <button
                      *ngIf="dataItem.canEditNonStockLine"
                      mat-menu-item
                      (click)="deleteLine(dataItem)"
                    >
                      <mat-icon>delete</mat-icon>
                      <span>Delete Line</span>
                    </button>
                    <button
                      *ngIf="dataItem.canEditNonStockLine"
                      mat-menu-item
                      (click)="editNonStockLine(dataItem)"
                    >
                      <mat-icon>edit</mat-icon>
                      <span>Edit Line</span>
                    </button>
                    <button
                      *ngIf="dataItem.isNonStockLine"
                      mat-menu-item
                      (click)="viewNonStockDetails(dataItem)"
                    >
                      <mat-icon>info</mat-icon>
                      <span>View Details</span>
                    </button>
                  </mat-menu>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [locked]="true"
                [width]="75"
                title=""
                class="td-action"
              >
                <ng-template
                  kendoGridCellTemplate
                  let-dataItem
                  let-rowIndex="rowIndex"
                >
                  <div
                    style="
                      display: flex;
                      flex-direction: row;
                      align-content: center;
                    "
                  >
                    <!-- <div *ngIf="dataItem.lineType === '7'"><img style="height: 16px;" src="/assets/images/Window_World_Logo.jpg" /></div> -->
                    <mat-icon *ngIf="dataItem.canAddCoriguard">shield</mat-icon>
                    <mat-icon *ngIf="dataItem.canRemoveCoriguard"
                      >verified_user</mat-icon
                    >
                    <mat-icon *ngIf="dataItem.isCoriguard"
                      >local_police</mat-icon
                    >
                    <mat-icon *ngIf="dataItem.isDeliveryFee"
                      >local_shipping</mat-icon
                    >
                    <mat-icon *ngIf="dataItem.isMiscCharge">handyman</mat-icon>
                    <mat-icon *ngIf="dataItem.lineDepositRequired > 0"
                      >attach_money</mat-icon
                    >
                    <mat-icon *ngIf="dataItem.discountReasonCode"
                      >sell</mat-icon
                    >
                    <mat-icon *ngIf="mode === 'SYSPRO' && dataItem.invoiced"
                      >done_all</mat-icon
                    >
                    <mat-icon
                      *ngIf="
                        mode === 'SYSPRO' &&
                        !dataItem.invoiced &&
                        dataItem.invoicedQty > 0
                      "
                      >done
                    </mat-icon>
                    <mat-icon *ngIf="dataItem.comments">comment</mat-icon>

                  </div>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [locked]="true"
                [width]="140"
                field="displayCode"
                title="Code"
              >
                <ng-template
                  kendoGridCellTemplate
                  let-dataItem
                  let-rowIndex="rowIndex"
                >
                  <ng-container
                    *ngIf="
                      dataItem.lineType === '1' &&
                        dataItem.isCoriguard === false;
                      else textCode
                    "
                  >
                    <a
                      [routerLink]="
                        '/generic/detail-page/stock-code-details/' +
                        dataItem.displayCode
                      "
                    >
                      {{ dataItem.displayCode }}
                    </a>
                  </ng-container>
                  <ng-template #textCode>
                    {{ dataItem.displayCode }}
                  </ng-template>
                </ng-template>
                <ng-template kendoGridFooterTemplate>
                  Order Totals
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [locked]="true"
                [width]="420"
                title="Description"
              >
                <ng-template
                  kendoGridCellTemplate
                  let-dataItem
                  let-rowIndex="rowIndex"
                >
                  <span class="ellipse">{{
                    dataItem.lineDescription2
                      ? dataItem.lineDescription +
                        " - " +
                        dataItem.lineDescription2
                      : dataItem.lineDescription
                  }}</span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [hidden]="compactView === true"
                [width]="100"
                field="lineNumber"
                title="Line"
              >
            </kendo-grid-column>
              <kendo-grid-column
                [width]="100"
                field="warehouseCode"
                title="Warehouse"
              >
              </kendo-grid-column>
              <kendo-grid-column
                [hidden]="compactView === true"
                [width]="250"
                field="warehouseDesc"
                title="Warehouse Desc"
              >
                <ng-template
                  kendoGridCellTemplate
                  let-dataItem
                  let-rowIndex="rowIndex"
                >
                  <span class="ellipse">{{ dataItem.warehouseDesc }}</span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column *ngIf="mode !== 'SYSPRO' && salesOrder.orderStatus === 'OPEN'"
                [hidden]="compactView === true"
                [width]="130"
                format="{0:n0}"
                class="td-number"
                field="leadTime"
                title="Lead Time (Days)"
              >
                <ng-template kendoGridFooterTemplate>
                  <div class="td-number">
                    {{ salesOrder.leadTime | number : "1.0-0" }}
                  </div>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [width]="200"
                field="deliveryMethod"
                title="Del. Method"
              >
                <ng-template
                  kendoGridCellTemplate
                  let-dataItem
                  let-rowIndex="rowIndex"
                >
                  <span class="ellipse">{{ dataItem.deliveryMethod }}</span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [width]="100"
                field="orderQty"
                format="{0:n0}"
                class="td-number"
                title="Qty"
              >
                <ng-template kendoGridFooterTemplate>
                  <div class="td-number">
                    {{ salesOrder.orderQty | number : "1.0-0" }}
                  </div>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [hidden]="mode !== 'SYSPRO'"
                [width]="100"
                field="shipQty"
                format="{0:n0}"
                class="td-number"
                title="Ship Qty"
              >
              </kendo-grid-column>

              <kendo-grid-column
                [hidden]="mode !== 'SYSPRO'"
                [width]="100"
                field="backOrderQty"
                format="{0:n0}"
                class="td-number"
                title="BO Qty"
              >
              </kendo-grid-column>

              <kendo-grid-column
                [hidden]="mode !== 'SYSPRO' || compactView === true"
                [width]="100"
                field="invoicedQty"
                format="{0:n0}"
                class="td-number"
                title="Inv. Qty"
              >
              </kendo-grid-column>

              <kendo-grid-column
                [width]="130"
                format="{0:n2}"
                class="td-number"
                field="unitRspIncludingVat"
                title="RSP Incl."
              >
              </kendo-grid-column>

              <kendo-grid-column
                [hidden]="compactView === true"
                [width]="100"
                format="{0:n2}"
                class="td-number"
                field="discountPercentage"
                title="Disc. Perc."
              >
              </kendo-grid-column>

              <kendo-grid-column
                [hidden]="compactView === true"
                [width]="130"
                format="{0:n2}"
                class="td-number"
                field="discountValue"
                title="Disc. Amt."
              >
              </kendo-grid-column>

              <kendo-grid-column
                [hidden]="compactView === true"
                [width]="100"
                field="discountValueFlag"
                title="Disc. Flag"
              >
              </kendo-grid-column>

              <kendo-grid-column
                [hidden]="compactView === true"
                [width]="100"
                field="contract"
                title="Contract"
              >
                <ng-template
                  kendoGridCellTemplate
                  let-dataItem
                  let-rowIndex="rowIndex"
                >
                  <span class="ellipse">{{ dataItem.contract }}</span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [hidden]="compactView === true"
                [width]="100"
                field="discountReasonCode"
                title="Disc. Reason"
              >
              </kendo-grid-column>

              <kendo-grid-column
                [width]="130"
                format="{0:n2}"
                class="td-number"
                field="lineDiscountAmount"
                title="Line Disc."
              >
                <ng-template kendoGridFooterTemplate>
                  <div class="td-number">
                    {{ salesOrder.discountAmount | number : "1.2-2" }}
                  </div>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [width]="130"
                format="{0:n2}"
                class="td-number"
                field="lineTotalAmount"
                title="Line Amt."
              >
                <ng-template kendoGridFooterTemplate>
                  <div class="td-number">
                    {{ salesOrder.totalAmount | number : "1.2-2" }}
                  </div>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [hidden]="compactView === true"
                [width]="130"
                format="{0:n2}"
                class="td-number"
                field="lineVatAmount"
                title="Line Vat"
              >
                <ng-template kendoGridFooterTemplate>
                  <div class="td-number">
                    {{ salesOrder.vatAmount | number : "1.2-2" }}
                  </div>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [hidden]="compactView === true"
                [width]="130"
                format="{0:n2}"
                class="td-number"
                field="lineDepositRequired"
                title="Deposit Required"
              >
                <ng-template kendoGridFooterTemplate>
                  <div class="td-number">
                    {{ salesOrder.depositRequired | number : "1.2-2" }}
                  </div>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [hidden]="compactView === true"
                [width]="50"
                title="CG Allowed"
              >
                <ng-template
                  kendoGridCellTemplate
                  let-dataItem
                  let-rowIndex="rowIndex"
                >
                  <ng-container
                    *ngIf="
                      dataItem.lineType === '1' &&
                      dataItem.isCoriguard === false
                    "
                  >
                    <div
                      style="
                        display: flex;
                        flex-direction: row;
                        align-content: center;
                      "
                    >
                      <ng-container
                        *ngIf="
                          dataItem.coriguardAllowed;
                          else NOcoriguardAllowed
                        "
                      >
                        <mat-icon>done</mat-icon>
                      </ng-container>
                      <ng-template #NOcoriguardAllowed>
                        <mat-icon>close</mat-icon>
                      </ng-template>
                    </div>
                  </ng-container>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [hidden]="compactView === true"
                [width]="50"
                title="Limited"
              >
                <ng-template
                  kendoGridCellTemplate
                  let-dataItem
                  let-rowIndex="rowIndex"
                >
                  <ng-container
                    *ngIf="
                      dataItem.lineType === '1' &&
                      dataItem.isCoriguard === false
                    "
                  >
                    <div
                      style="
                        display: flex;
                        flex-direction: row;
                        align-content: center;
                      "
                    >
                      <ng-container
                        *ngIf="
                          dataItem.limitedInventory;
                          else NOlimitedInventory
                        "
                      >
                        <mat-icon>done</mat-icon>
                      </ng-container>
                      <ng-template #NOlimitedInventory>
                        <mat-icon>close</mat-icon>
                      </ng-template>
                    </div>
                  </ng-container>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [hidden]="compactView === true"
                [width]="50"
                title="Sell of Floor"
              >
                <ng-template
                  kendoGridCellTemplate
                  let-dataItem
                  let-rowIndex="rowIndex"
                >
                  <ng-container
                    *ngIf="
                      dataItem.lineType === '1' &&
                      dataItem.isCoriguard === false
                    "
                  >
                    <div
                      style="
                        display: flex;
                        flex-direction: row;
                        align-content: center;
                      "
                    >
                      <ng-container
                        *ngIf="
                          dataItem.sellOfFloorAllowed;
                          else NOsellOfFloorAllowed
                        "
                      >
                        <mat-icon>done</mat-icon>
                      </ng-container>
                      <ng-template #NOsellOfFloorAllowed>
                        <mat-icon>close</mat-icon>
                      </ng-template>
                    </div>
                  </ng-container>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                [hidden]="compactView === true"
                [width]="100"
                field="partCategory"
                title="Category"
              >
              </kendo-grid-column>
            </kendo-grid>
          </div>
        </mat-card-content>
        <mat-card-footer>
          <div class="card-footer-container">
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-content: center;
              "
            >
              <div>
                <button
                  *ngIf="salesOrder.canAddExternalItem"
                  mat-button
                  color="primary"
                  (click)="addExternalLine(salesOrder)"
                >
                  Add External Line
                </button>
                <button
                  *ngIf="salesOrder.canAddLines"
                  mat-button
                  color="primary"
                  (click)="scan()"
                >
                  Scan Items
                </button>
                <button
                  *ngIf="salesOrder.canAddLines"
                  mat-button
                  color="primary"
                  (click)="searchItems()"
                >
                  Search Items
                </button>
                <button
                  *ngIf="salesOrder.canAddLines"
                  mat-button
                  color="primary"
                  (click)="searchItemsEcom()"
                >
                  Advanced Search
                </button>
                <button
                  *ngIf="salesOrder.canAddDeliveryFee"
                  mat-button
                  color="primary"
                  (click)="addDeliverFee()"
                >
                  Add Delivery Fee
                </button>
                <button
                  *ngIf="salesOrder.canAddMiscCharge"
                  mat-button
                  color="primary"
                  (click)="addMiscCharge()"
                >
                  Add Misc. Charge
                </button>
                <button
                  *ngIf="salesOrder.canInvoiceLines"
                  mat-button
                  color="primary"
                  (click)="invoiceLines()"
                >
                  Invoice Lines
                </button>
                <button
                  *ngIf="salesOrder.comments"
                  mat-button
                  color="primary"
                  (click)="showComments(salesOrder.comments)"
                >
                  Show Order Comments
                </button>
              </div>
              <div style="margin-right: 16px">
                <mat-slide-toggle [color]="primary" [(ngModel)]="compactView"
                  >Compact View</mat-slide-toggle
                >
              </div>
            </div>
          </div>
        </mat-card-footer>
      </mat-card>
    </div>

    <!-- TFG Rewards Campaign Details  -->
    <div *ngIf="salesOrder.tfgCampaignDetailsAll || salesOrder.tfgCampaignDetails" style="width: 100%; margin: 8px 0px 0px 0px">
      <ng-container *ngIf="mode === 'SYSPRO'; then tfgRewardsCampaignsSysproOrderTemplate; else tfgRewardsCampaignsQuoteTemplate">
      </ng-container>
    </div>

    <div
      fxLayout="row wrap"
      style="width: 100%; margin-top: 8px; margin-bottom: 8px"
    >
      <div fxFlex="50%" style="display: flex; padding-right: 4px">
        <ng-container
          *ngIf="mode === 'SYSPRO'; then notesTemplate; else notesTemplate"
        ></ng-container>
      </div>
      <div fxFlex="50%" style="display: flex; padding-left: 4px">
        <ng-container
          *ngIf="
            mode === 'SYSPRO';
            then depositsTemplate;
            else paymentLinksTemplate
          "
        ></ng-container>
      </div>

      <div
        fxFlex="50%"
        style="
          display: flex;
          padding-right: 4px;
          padding-top: 8px;
          padding-bottom: 8px;
        "
      >
        <ng-container
          *ngIf="mode === 'SYSPRO'; then emailsTemplate; else emailsTemplate"
        ></ng-container>
      </div>
      <div
        fxFlex="50%"
        style="
          display: flex;
          padding-left: 4px;
          padding-top: 8px;
          padding-bottom: 8px;
        "
      >
        <ng-container
          *ngIf="mode === 'SYSPRO'; then invoicesTemplate; else emptyTemplate"
        ></ng-container>
      </div>

      <div fxFlex="50%" style="display: flex; padding-right: 4px">
        <ng-container
          *ngIf="
            mode === 'SYSPRO';
            then documentsTemplate;
            else documentsTemplate
          "
        ></ng-container>
      </div>
      <div fxFlex="50%" style="display: flex; padding-left: 4px">
        <ng-container
          *ngIf="mode === 'SYSPRO'; then paymentsTemplate; else emptyTemplate"
        ></ng-container>
      </div>

      <div
        fxFlex="50%"
        style="
          display: flex;
          padding-left: 4px;
          padding-top: 8px;
          padding-bottom: 8px;
        "
      >
        <ng-container
          *ngIf="mode === 'SYSPRO'; then emptyTemplate; else emptyTemplate"
        ></ng-container>
      </div>
      <div
        fxFlex="50%"
        style="
          display: flex;
          padding-left: 4px;
          padding-top: 8px;
          padding-bottom: 8px;
        "
      >
        <ng-container
          *ngIf="
            mode === 'SYSPRO';
            then eftRequestsTemplate;
            else emptyTemplate
          "
        ></ng-container>
      </div>

      <div
        fxFlex="50%"
        style="
          display: flex;
          padding-left: 4px;
          padding-top: 8px;
          padding-bottom: 8px;
        "
      >
        <ng-container
          *ngIf="mode === 'SYSPRO'; then emptyTemplate; else emptyTemplate"
        ></ng-container>
      </div>
      <div
        fxFlex="50%"
        style="
          display: flex;
          padding-left: 4px;
          padding-top: 8px;
          padding-bottom: 8px;
        "
      >
        <ng-container
          *ngIf="
            mode === 'SYSPRO';
            then tfgPaymentsTemplate;
            else emptyTemplate
          "
        ></ng-container>
      </div>

      <div
        fxFlex="100%"
        style="
          display: flex;
          padding-left: 4px;
          padding-top: 8px;
          padding-bottom: 8px;
        "
      >
        <ng-container
          *ngIf="
            mode === 'SYSPRO';
            then callbacksTemplate;
            else callbacksTemplate
          "
        ></ng-container>
      </div>

      <div
        fxFlex="100%"
        style="
          display: flex;
          padding-left: 4px;
          padding-top: 8px;
          padding-bottom: 8px;
        "
      >
        <ng-container
          *ngIf="mode === 'SYSPRO'; then surveysTemplate; else surveysTemplate"
        ></ng-container>
      </div>

      <div
        fxFlex="100%"
        style="
          display: flex;
          padding-left: 4px;
          padding-top: 8px;
          padding-bottom: 8px;
        "
      >
        <ng-container
          *ngIf="mode === 'SYSPRO'; then sysproLogsTemplate; else emptyTemplate"
        ></ng-container>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #loadingTemplate>
  <mat-card>
    <mat-card-content>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          align-content: center;
          margin: 32px;
        "
      >
        Fetching order details, please wait....
      </div>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </mat-card-content>
  </mat-card>
</ng-template>

<!-- sysproLogsTemplate -->
<ng-template #sysproLogsTemplate>
  <mat-card style="align-self: stretch; overflow-x: auto; overflow-y: hidden">
    <mat-card-content>
      <mat-card-subtitle>
        <div class="card-title-container">
          <div>SYSPRO Transactions</div>
        </div>
      </mat-card-subtitle>
      <div style="width: 100%">
        <kendo-grid
          style="max-height: 250px"
          [kendoGridBinding]="salesOrder.sysproLog"
          [scrollable]="true"
          [resizable]="true"
          [reorderable]="true"
          [sortable]="true"
        >
          <kendo-grid-column [width]="70" field="lineNumber" title="Line">
          </kendo-grid-column>
          <kendo-grid-column [width]="150" field="logAction" title="Action">
          </kendo-grid-column>
          <kendo-grid-column [width]="400" field="logInfo" title="Info">
          </kendo-grid-column>
          <kendo-grid-column [width]="200" field="store" title="Store">
          </kendo-grid-column>
          <kendo-grid-column [width]="200" field="createdBy" title="User">
          </kendo-grid-column>
          <kendo-grid-column [width]="170" field="createdAt" title="Date">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.createdAt | date : "MMM d, yyyy HH:mm:ss" }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [width]="110"
            field="invoiceNumber"
            title="Invoice"
          >
          </kendo-grid-column>
          <kendo-grid-column
            [width]="110"
            field="creditSalesOrderNumber"
            title="Credit Order"
          >
          </kendo-grid-column>
          <kendo-grid-column
            [width]="110"
            field="creditInvoiceNumber"
            title="Credit Invoice"
          >
          </kendo-grid-column>
        </kendo-grid>
      </div>
    </mat-card-content>
    <mat-card-footer> </mat-card-footer>
  </mat-card>
</ng-template>

<!-- Deoposits -->
<ng-template #depositsTemplate>
  <mat-card style="align-self: stretch; overflow-x: auto; overflow-y: hidden">
    <mat-card-content>
      <mat-card-subtitle>
        <div class="card-title-container">
          <div>Deposits Transactions</div>
          <div>
            <button
              style="margin-right: 16px"
              matTooltip="Generate Payment Receipts Document"
              *ngIf="salesOrder?.canCreatePayments"
              mat-icon-button
              (click)="
                generateReceiptDocument(salesOrder.createPaymentsPayload)
              "
            >
              <mat-icon>post_add</mat-icon>
            </button>
            <!-- <button
              style="margin-right: 16px"
              matTooltip="Download Payment Receipts Document"
              *ngIf="salesOrder?.canDownloadPayments"
              mat-icon-button
              (click)="downloadResource(salesOrder.paymentsResource)"
            >
              <mat-icon>download</mat-icon>
            </button>
            <button
              style="margin-right: 16px"
              matTooltip="Email Payment Receipts Document"
              *ngIf="salesOrder?.canDownloadPayments"
              mat-icon-button
              (click)="emailDocument(salesOrder.paymentEmail)"
            >
              <mat-icon>forward_to_inbox</mat-icon>
            </button> -->
            <button
              style="margin-right: 16px"
              *ngIf="salesOrder.canAddDeposit"
              [matTooltip]="'Add Deposit'"
              mat-icon-button
              (click)="addDeposit()"
            >
              <mat-icon>payments</mat-icon>
            </button>
            <button
              style="margin-right: 16px"
              *ngIf="salesOrder.canReleaseDeposit"
              [matTooltip]="'Refund Deposit'"
              mat-icon-button
              (click)="refundDeposit()"
            >
              <mat-icon>credit_card_off</mat-icon>
            </button>
            <button
              style="margin-right: 16px"
              *ngIf="salesOrder.canReleaseDeposit"
              [matTooltip]="'EFT Refund Request'"
              mat-icon-button
              (click)="eftRefundRequest()"
            >
              <mat-icon>account_balance</mat-icon>
            </button>
            <button
              style="margin-right: 16px"
              *ngIf="salesOrder.canReleaseDeposit"
              [matTooltip]="'Transfer Deposit'"
              mat-icon-button
              (click)="transferDeposit()"
            >
              <mat-icon>move_down</mat-icon>
            </button>
            <button
              [matTooltip]="'Refresh Details'"
              mat-icon-button
              (click)="refresh()"
            >
              <mat-icon>refresh</mat-icon>
            </button>

            <!-- <button *ngIf="salesOrder.canAddDeposit || salesOrder.canReleaseDeposit" mat-icon-button [matMenuTriggerFor]="menuDeposits">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menuDeposits="matMenu">
                  <button *ngIf="salesOrder.canAddDeposit" mat-menu-item (click)="addDeposit()">
                    <mat-icon>payments</mat-icon>
                    <span>Add Deposit</span>
                  </button>
                  <button *ngIf="salesOrder.canReleaseDeposit" mat-menu-item (click)="refundDeposit()">
                    <mat-icon>credit_card_off</mat-icon>
                    <span>Refund Deposit</span>
                  </button>
                  <button *ngIf="salesOrder.canReleaseDeposit" mat-menu-item (click)="transferDeposit()">
                    <mat-icon>move_down</mat-icon>
                    <span>Transfer Deposit</span>
                  </button>
                </mat-menu> -->
          </div>
        </div>
      </mat-card-subtitle>
      <div style="width: 100%">
        <kendo-grid
          style="max-height: 250px"
          [kendoGridBinding]="salesOrder.deposits"
          [scrollable]="true"
          [resizable]="true"
          [reorderable]="true"
          [sortable]="true"
        >
          <kendo-grid-column [width]="130" field="transactionDate" title="Date">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.transactionDate | date : "MMM d, yyyy" }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column [width]="130" field="transactionType" title="Type">
            <ng-template kendoGridFooterTemplate>
              <div>Balance</div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [width]="130"
            format="{0:n2}"
            class="td-number"
            field="transactionAmount"
            title="Amount"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="td-number">
                {{ dataItem.transactionAmount | number : "1.2-2" }}
              </div>
            </ng-template>
            <ng-template kendoGridFooterTemplate>
              <div class="td-number">
                {{ salesOrder.depositReceived | number : "1.2-2" }}
              </div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column [width]="200" field="containerDesc" title="Method">
          </kendo-grid-column>
          <kendo-grid-column [width]="250" field="storeName" title="Store">
          </kendo-grid-column>
          <kendo-grid-column [width]="250" field="userName" title="User">
          </kendo-grid-column>
          <kendo-grid-column [width]="250" field="refundReason" title="Refund Reason">
          </kendo-grid-column>
        </kendo-grid>
      </div>
    </mat-card-content>
    <mat-card-footer> </mat-card-footer>
  </mat-card>
</ng-template>

<!-- Payment Links -->
<ng-template #paymentLinksTemplate>
  <mat-card style="align-self: stretch; overflow-x: auto; overflow-y: hidden">
    <mat-card-content>
      <mat-card-subtitle>
        <div class="card-title-container">
          <div>Payment Links</div>
          <div>
            <button
              [matTooltip]="'Refresh Details'"
              mat-icon-button
              (click)="refresh()"
            >
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </div>
      </mat-card-subtitle>
      <div>
        <kendo-grid
          style="max-height: 250px"
          [kendoGridBinding]="salesOrder.paymentLinks"
          [scrollable]="true"
          [resizable]="true"
          [reorderable]="true"
          [sortable]="true"
        >
          <kendo-grid-column [width]="30" title="" class="td-action">
            <ng-template
              kendoGridCellTemplate
              let-dataItem
              let-rowIndex="rowIndex"
            >
              <button
                *ngIf="dataItem.link"
                mat-icon-button
                (click)="copyLink(dataItem)"
              >
                <mat-icon>content_copy</mat-icon>
              </button>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column [width]="130" field="linkType" title="Type">
          </kendo-grid-column>
          <kendo-grid-column
            [width]="130"
            format="{0:n2}"
            class="td-number"
            field="amount"
            title="Amount"
          >
          </kendo-grid-column>
          <kendo-grid-column [width]="150" field="createdAt" title="Created At">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.createdAt | date : "MMM d, yyyy" }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column [width]="150" field="paidAt" title="Paid At">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.paidAt | date : "MMM d, yyyy" }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [width]="200"
            field="integration"
            title="Integration"
          >
          </kendo-grid-column>
        </kendo-grid>
      </div>
    </mat-card-content>
    <mat-card-footer> </mat-card-footer>
  </mat-card>
</ng-template>

<!-- Invoices -->
<ng-template #invoicesTemplate>
  <mat-card style="align-self: stretch; overflow-x: auto; overflow-y: hidden">
    <mat-card-content>
      <mat-card-subtitle>
        <div class="card-title-container">
          <div>Invoices</div>
          <div>
            <button
              [matTooltip]="'Refresh Details'"
              mat-icon-button
              (click)="refresh()"
            >
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </div>
      </mat-card-subtitle>
      <div>
        <div style="width: 100%">
          <kendo-grid
            style="max-height: 250px"
            [kendoGridBinding]="salesOrder.invoices"
            [scrollable]="true"
            [resizable]="true"
            [reorderable]="true"
            [sortable]="true"
          >
            <kendo-grid-column [width]="30" title="" class="td-action">
              <ng-template
                kendoGridCellTemplate
                let-dataItem
                let-rowIndex="rowIndex"
              >
                <button
                  *ngIf="
                    dataItem.canPayInvoice || dataItem.canPayInvoiceWithDeposit
                  "
                  mat-icon-button
                  [matMenuTriggerFor]="rowMenu"
                  aria-label="Example icon-button with a menu"
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #rowMenu="matMenu">
                  <button
                    *ngIf="dataItem.canPayInvoice"
                    mat-menu-item
                    (click)="payInvoice(dataItem)"
                  >
                    <mat-icon>payments</mat-icon>
                    <span>Pay</span>
                  </button>
                  <button
                    *ngIf="dataItem.canPayInvoiceWithDeposit"
                    mat-menu-item
                    (click)="payInvoiceWithDeposit(dataItem)"
                  >
                    <mat-icon>payments</mat-icon>
                    <span>Pay with Deposit</span>
                  </button>
                </mat-menu>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column [width]="50" title="" class="td-action">
              <ng-template
                kendoGridCellTemplate
                let-dataItem
                let-rowIndex="rowIndex"
              >
                <button
                  matTooltip="Generate Invoice Document"
                  *ngIf="dataItem.canCreateInvoice"
                  mat-icon-button
                  (click)="generateInvoiceDocument(dataItem)"
                >
                  <mat-icon>post_add</mat-icon>
                </button>
                <button
                  matTooltip="Download Invoice Document"
                  *ngIf="dataItem.canDownloadInvoice"
                  mat-icon-button
                  (click)="downloadResource(dataItem.resource)"
                >
                  <mat-icon>download</mat-icon>
                </button>
                <button
                  matTooltip="Email Invoice Document"
                  *ngIf="dataItem.canDownloadInvoice"
                  mat-icon-button
                  (click)="emailDocument(dataItem.email)"
                >
                  <mat-icon>forward_to_inbox</mat-icon>
                </button>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column
              [width]="110"
              field="invoiceNumber"
              title="Invoice"
            >
              <ng-template kendoGridCellTemplate let-dataItem>
                <a [routerLink]="['/pos/invoices/' + dataItem.invoiceNumber]">{{
                  dataItem.invoiceNumber
                }}</a>
              </ng-template>
              <ng-template kendoGridFooterTemplate>
                <div>Total</div>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column [width]="110" field="invoiceDate" title="Date">
              <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem.invoiceDate | date : "MMM d, yyyy" }}
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column
              [width]="100"
              format="{0:n2}"
              class="td-number"
              field="Amount"
              title="Amount"
            >
              <ng-template kendoGridCellTemplate let-dataItem>
                <div class="td-number">
                  {{ dataItem.invoiceAmount | number : "1.2-2" }}
                </div>
              </ng-template>
              <ng-template kendoGridFooterTemplate>
                <div class="td-number">
                  {{ salesOrder.invoiceAmount | number : "1.2-2" }}
                </div>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column
              [width]="100"
              format="{0:n2}"
              class="td-number"
              field="invoiceBalance"
              title="Balance"
            >
              <ng-template kendoGridCellTemplate let-dataItem>
                <div
                  [ngClass]="{
                    'os-warning-text': dataItem.invoiceBalance !== 0
                  }"
                  class="td-number"
                >
                  {{ dataItem.invoiceBalance | number : "1.2-2" }}
                </div>
              </ng-template>
              <ng-template kendoGridFooterTemplate>
                <div
                  [ngClass]="{
                    'os-warning-text': salesOrder.invoiceBalance !== 0
                  }"
                  class="td-number"
                >
                  {{ salesOrder.invoiceBalance | number : "1.2-2" }}
                </div>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column
              [width]="200"
              field="createdBy"
              title="Created By"
            >
            </kendo-grid-column>
          </kendo-grid>
        </div>
      </div>
    </mat-card-content>
    <mat-card-footer> </mat-card-footer>
  </mat-card>
</ng-template>

<!-- Empty Template -->
<ng-template #emptyTemplate> </ng-template>

<!-- Payments -->
<ng-template #paymentsTemplate>
  <mat-card style="align-self: stretch; overflow-x: auto; overflow-y: hidden">
    <mat-card-content>
      <mat-card-subtitle>
        <div class="card-title-container">
          <div>Payments</div>
          <div>
            <button
              style="margin-right: 16px"
              matTooltip="Generate Payment Receipts Document"
              *ngIf="salesOrder?.canCreatePayments"
              mat-icon-button
              (click)="
                generateReceiptDocument(salesOrder.createPaymentsPayload)
              "
            >
              <mat-icon>post_add</mat-icon>
            </button>
            <!-- <button
              style="margin-right: 16px"
              matTooltip="Download Payment Receipts Document"
              *ngIf="salesOrder?.canDownloadPayments"
              mat-icon-button
              (click)="downloadResource(salesOrder.paymentsResource)"
            >
              <mat-icon>download</mat-icon>
            </button>
            <button
              style="margin-right: 16px"
              matTooltip="Email Payment Receipts Document"
              *ngIf="salesOrder?.canDownloadPayments"
              mat-icon-button
              (click)="emailDocument(salesOrder.paymentEmail)"
            >
              <mat-icon>forward_to_inbox</mat-icon>
            </button> -->
            <button
              [matTooltip]="'Refresh Details'"
              mat-icon-button
              (click)="refresh()"
            >
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </div>
      </mat-card-subtitle>
      <div>
        <kendo-grid
          style="max-height: 250px"
          [kendoGridBinding]="salesOrder.payments"
          [scrollable]="true"
          [resizable]="true"
          [reorderable]="true"
          [sortable]="true"
        >
          <kendo-grid-column [width]="75" title="" class="td-action">
            <ng-template
              kendoGridCellTemplate
              let-dataItem
              let-rowIndex="rowIndex"
            >
              <button
                matTooltip="Generate TFG Payment Receipt"
                *ngIf="dataItem.canCreateReceipt"
                mat-icon-button
                (click)="generateTfgDocument(dataItem)"
              >
                <mat-icon>post_add</mat-icon>
              </button>
              <button
                matTooltip="Download TFG Payment Receipt Document"
                *ngIf="dataItem.canDownloadReceipt"
                mat-icon-button
                (click)="downloadTfgResource(dataItem.resource)"
              >
                <mat-icon>download</mat-icon>
              </button>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column [width]="160" field="paymentType" title="Type">
          </kendo-grid-column>
          <kendo-grid-column
            [width]="130"
            field="invoiceNumber"
            title="Invoice"
          >
          </kendo-grid-column>
          <kendo-grid-column [width]="180" field="containerDesc" title="Method">
          </kendo-grid-column>
          <kendo-grid-column
            [width]="130"
            format="{0:n2}"
            class="td-number"
            field="amountPaid"
            title="Amount"
          >
          </kendo-grid-column>
          <kendo-grid-column [width]="150" field="creationDate" title="Paid At">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.creationDate | date : "MMM d, yyyy" }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column [width]="70" field="paymentVoided" title="Voided">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.paymentVoided ? "Yes" : "No" }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column [width]="70" field="isProvisional" title="Paid At">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.isProvisional ? "Yes" : "No" }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [width]="200"
            field="userDisplayName"
            title="Capture By"
          >
          </kendo-grid-column>
          <kendo-grid-column
            [width]="200"
            field="refundReason"
            title="Refund Reason"
          >
          </kendo-grid-column>
        </kendo-grid>
      </div>
    </mat-card-content>
    <mat-card-footer> </mat-card-footer>
  </mat-card>
</ng-template>

<!-- TFG Payments -->
<ng-template #tfgPaymentsTemplate>
  <mat-card style="align-self: stretch; overflow-x: auto; overflow-y: hidden">
    <mat-card-content>
      <mat-card-subtitle>
        <div class="card-title-container">
          <div>TFG Increase OTB Payments</div>
          <div></div>
        </div>
      </mat-card-subtitle>
      <div>
        <kendo-grid
          style="max-height: 250px"
          [kendoGridBinding]="salesOrder.tfgPayments"
          [scrollable]="true"
          [resizable]="true"
          [reorderable]="true"
          [sortable]="true"
        >
          <kendo-grid-column [width]="75" title="" class="td-action">
            <ng-template
              kendoGridCellTemplate
              let-dataItem
              let-rowIndex="rowIndex"
            >
              <button
                matTooltip="Generate TFG Payment Receipt"
                *ngIf="dataItem.canCreateReceipt"
                mat-icon-button
                (click)="generateTfgDocument(dataItem)"
              >
                <mat-icon>post_add</mat-icon>
              </button>
              <button
                matTooltip="Download TFG Payment Receipt Document"
                *ngIf="dataItem.canDownloadReceipt"
                mat-icon-button
                (click)="downloadTfgResource(dataItem.resource)"
              >
                <mat-icon>download</mat-icon>
              </button>
              <button
                matTooltip="Undo TFG Account Payment"
                *ngIf="dataItem.canReversePayment"
                mat-icon-button
                (click)="reverseTfgOtbPayment(dataItem)"
              >
                <mat-icon>undo</mat-icon>
              </button>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column [width]="160" field="paymentType" title="Type">
          </kendo-grid-column>
          <kendo-grid-column
            [width]="130"
            field="invoiceNumber"
            title="Invoice"
          >
          </kendo-grid-column>
          <kendo-grid-column [width]="180" field="containerDesc" title="Method">
          </kendo-grid-column>
          <kendo-grid-column
            [width]="130"
            format="{0:n2}"
            class="td-number"
            field="amountPaid"
            title="Amount"
          >
          </kendo-grid-column>
          <kendo-grid-column [width]="150" field="creationDate" title="Paid At">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.creationDate | date : "MMM d, yyyy" }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column [width]="70" field="paymentVoided" title="Voided">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.paymentVoided ? "Yes" : "No" }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column [width]="70" field="isProvisional" title="Paid At">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.isProvisional ? "Yes" : "No" }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [width]="200"
            field="userDisplayName"
            title="Capture By"
          >
          </kendo-grid-column>
        </kendo-grid>
      </div>
    </mat-card-content>
    <mat-card-footer> </mat-card-footer>
  </mat-card>
</ng-template>

<!-- Notes -->
<ng-template #notesTemplate>
  <mat-card style="align-self: stretch; overflow-x: auto; overflow-y: hidden">
    <mat-card-content>
      <mat-card-subtitle>
        <div class="card-title-container">
          <div>Notes</div>
          <div>
            <button
              *ngIf="salesOrder.canAddNote"
              [matTooltip]="'Add Note'"
              mat-icon-button
              (click)="addNote()"
            >
              <mat-icon>textsms</mat-icon>
            </button>
            <button
              [matTooltip]="'Refresh Details'"
              mat-icon-button
              (click)="refresh()"
            >
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </div>
      </mat-card-subtitle>
      <div style="width: 100%">
        <kendo-grid
          style="max-height: 250px"
          [kendoGridBinding]="salesOrder.notes"
          [scrollable]="true"
          [resizable]="true"
          [reorderable]="true"
          [sortable]="true"
        >
          <kendo-grid-column [width]="35" title="" class="td-action">
            <ng-template
              kendoGridCellTemplate
              let-dataItem
              let-rowIndex="rowIndex"
            >
              <button
                *ngIf="dataItem.canDeleteNote"
                mat-icon-button
                (click)="deleteNote(dataItem)"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [width]="110"
            field="creationDate"
            title="Created At"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.creationDate | date : "MMM d, yyyy HH:mm" }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [width]="200"
            field="salesOrderNoteText"
            title="Note"
            ><ng-template kendoGridCellTemplate let-dataItem>
              <span style="white-space: break-spaces">
                {{ dataItem.salesOrderNoteText }}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [width]="130"
            field="creationUserDisplayName"
            title="User"
          >
          </kendo-grid-column>
        </kendo-grid>
      </div>
    </mat-card-content>
    <mat-card-footer> </mat-card-footer>
  </mat-card>
</ng-template>

<!-- Emails -->
<ng-template #emailsTemplate>
  <mat-card style="align-self: stretch; overflow-x: auto; overflow-y: hidden">
    <mat-card-content>
      <mat-card-subtitle>
        <div class="card-title-container">
          <div>Emails / SMSes</div>
          <div>
            <button
              *ngIf="salesOrder.canSendSms"
              [matTooltip]="'Send SMS'"
              mat-icon-button
              (click)="sendSMS()"
            >
              <mat-icon>textsms</mat-icon>
            </button>
            <button
              [matTooltip]="'Refresh Details'"
              mat-icon-button
              (click)="refresh()"
            >
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </div>
      </mat-card-subtitle>
      <div>
        <kendo-grid
          style="max-height: 250px"
          [kendoGridBinding]="salesOrder.emails"
          [scrollable]="true"
          [resizable]="true"
          [reorderable]="true"
          [sortable]="true"
        >
          <kendo-grid-column [width]="35" title="" class="td-action">
            <ng-template
              kendoGridCellTemplate
              let-dataItem
              let-rowIndex="rowIndex"
            >
              <button
                *ngIf="dataItem.customerEmailId"
                mat-icon-button
                (click)="resendCustomerEmail(dataItem)"
              >
                <mat-icon>forward_to_inbox</mat-icon>
              </button>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column [width]="150" field="emailType" title="Type">
          </kendo-grid-column>
          <kendo-grid-column
            [hidden]="mode !== 'SYSPRO'"
            [width]="200"
            field="invoiceNumber"
            title="Invoice"
          >
          </kendo-grid-column>
          <kendo-grid-column [width]="200" field="emailStatus" title="Status">
          </kendo-grid-column>
          <kendo-grid-column [width]="200" field="sentAt" title="Sent At">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.sentAt | date : "MMM d, yyyy HH:mm" }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column [width]="250" field="sentTo" title="Sent To">
          </kendo-grid-column>
          <!-- <kendo-grid-column [width]="200" field="stepStatus" title="Status"> </kendo-grid-column> -->
          <kendo-grid-column [width]="800" field="message" title="Content">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="ellipse">{{ dataItem.message }}</span>
            </ng-template>
          </kendo-grid-column>

          <ng-template
            kendoGridDetailTemplate
            let-dataItem
            [kendoGridDetailTemplateShowIf]="hasAttachments"
          >
            <kendo-grid
              [kendoGridBinding]="dataItem.attachments"
              [scrollable]="true"
              [resizable]="true"
              [reorderable]="true"
              [sortable]="true"
            >
              <kendo-grid-column [width]="35" title="" class="td-action">
                <ng-template
                  kendoGridCellTemplate
                  let-dataItem
                  let-rowIndex="rowIndex"
                >
                  <button
                    *ngIf="dataItem.resourceFileId"
                    mat-icon-button
                    (click)="downloadResource(dataItem)"
                  >
                    <mat-icon>download</mat-icon>
                  </button>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column
                [width]="200"
                field="resourceType"
                title="Attachment Type"
              >
              </kendo-grid-column>
              <kendo-grid-column
                field="fileName"
                title="Filename"
              >
              </kendo-grid-column>
            </kendo-grid>
          </ng-template>
        </kendo-grid>
      </div>
    </mat-card-content>
    <mat-card-footer> </mat-card-footer>
  </mat-card>
</ng-template>

<!-- Documents -->
<ng-template #documentsTemplate>
  <mat-card style="align-self: stretch; overflow-x: auto; overflow-y: hidden">
    <mat-card-content>
      <mat-card-subtitle>
        <div class="card-title-container">
          <div>Documents</div>
          <div>
            <button
              *ngIf="salesOrder.canUploadSupportingDocument"
              [matTooltip]="'Upload Supporting Document'"
              mat-icon-button
              (click)="uploadSupportingDocument()"
            >
              <mat-icon>upload_file</mat-icon>
            </button>
            <button
              [matTooltip]="'Refresh Details'"
              mat-icon-button
              (click)="refresh()"
            >
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </div>
      </mat-card-subtitle>
      <div style="width: 100%">
        <kendo-grid
          style="max-height: 250px"
          [kendoGridBinding]="salesOrder.resources"
          [scrollable]="true"
          [resizable]="true"
          [reorderable]="true"
          [sortable]="true"
        >
          <kendo-grid-column [width]="35" title="" class="td-action">
            <ng-template
              kendoGridCellTemplate
              let-dataItem
              let-rowIndex="rowIndex"
            >
              <button
                *ngIf="dataItem.resourceFileId"
                mat-icon-button
                (click)="downloadResource(dataItem)"
              >
                <mat-icon>download</mat-icon>
              </button>
              <button
                *ngIf="dataItem.isSupportingDocument"
                mat-icon-button
                (click)="deleteSupportingDocument(dataItem)"
              >
                <mat-icon>delete</mat-icon>
              </button>
              <button
                *ngIf="dataItem.canResendQuote"
                mat-icon-button
                (click)="resendQuote(dataItem)"
              >
                <mat-icon>forward_to_inbox</mat-icon>
              </button>
              <button
                *ngIf="dataItem.canResendPop"
                mat-icon-button
                (click)="resendPop(dataItem)"
              >
                <mat-icon>forward_to_inbox</mat-icon>
              </button>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [width]="130"
            field="resourceType"
            title="Doc. Type"
          >
          </kendo-grid-column>
          <kendo-grid-column
            [width]="130"
            field="creationDate"
            title="Created At"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.creationDate | date : "MMM d, yyyy HH:mm" }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [width]="130"
            field="userDisplayName"
            title="Uploaded By"
          >
          </kendo-grid-column>
        </kendo-grid>
      </div>
    </mat-card-content>
    <mat-card-footer> </mat-card-footer>
  </mat-card>
</ng-template>

<!-- EFT Request -->
<ng-template #eftRequestsTemplate>
  <mat-card style="align-self: stretch; overflow-x: auto; overflow-y: hidden">
    <mat-card-content>
      <mat-card-subtitle>
        <div class="card-title-container">
          <div>Refund Requests</div>
          <div>
            <button
              [matTooltip]="'Refresh Details'"
              mat-icon-button
              (click)="refresh()"
            >
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </div>
      </mat-card-subtitle>
      <div>
        <kendo-grid
          [kendoGridBinding]="salesOrder.eftRequests"
          [scrollable]="true"
          [resizable]="true"
          [reorderable]="true"
          [sortable]="true"
        >
          <kendo-grid-column
            [width]="130"
            format="{0:n2}"
            class="td-number"
            field="requestedAmount"
            title="Amount"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="td-number">
                {{ dataItem.requestedAmount | number : "1.2-2" }}
              </div>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column [width]="120" field="requestStatus" title="Status">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.requestStatus }}
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            [width]="100"
            field="requestedBranch"
            title="Requested Branch"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="ellipse">{{ dataItem.requestedBranch }}</span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            [width]="200"
            field="requestedAt"
            title="Requested At"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.requestedAt | date : "MMM d, yyyy HH:mm" }}
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            [width]="200"
            field="requestedBy"
            title="Requested By"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="ellipse">{{ dataItem.requestedBy }}</span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            [width]="200"
            field="requestedComment"
            title="Request Comment"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="ellipse">{{ dataItem.requestedComment }}</span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            [width]="200"
            field="refundReason"
            title="Refund Reason"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="ellipse">{{ dataItem.refundReason }}</span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            [width]="200"
            field="actionedAt"
            title="Actioned At"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.actionedAt | date : "MMM d, yyyy HH:mm" }}
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            [width]="200"
            field="actionedBy"
            title="Actioned By"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="ellipse">{{ dataItem.actionedBy }}</span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            [width]="200"
            field="actionedComment"
            title="Action Comment"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="ellipse">{{ dataItem.actionedComment }}</span>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </div>
    </mat-card-content>
    <mat-card-footer> </mat-card-footer>
  </mat-card>
</ng-template>

<!-- Callback Requests -->
<ng-template #callbacksTemplate>
  <mat-card style="align-self: stretch; overflow-x: auto; overflow-y: hidden">
    <mat-card-content>
      <mat-card-subtitle>
        <div class="card-title-container">
          <div>Callback Requests</div>
          <div>
            <button
              [matTooltip]="'Refresh Details'"
              mat-icon-button
              (click)="refresh()"
            >
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </div>
      </mat-card-subtitle>
      <div style="width: 100%">
        <kendo-grid
          style="max-height: 250px"
          [kendoGridBinding]="salesOrder.callbacks"
          [scrollable]="true"
          [resizable]="true"
          [reorderable]="true"
          [sortable]="true"
        >
          <kendo-grid-column [width]="35" title="" class="td-action">
            <ng-template
              kendoGridCellTemplate
              let-dataItem
              let-rowIndex="rowIndex"
            >
              <button
                *ngIf="dataItem.canModify"
                mat-icon-button
                (click)="editCallbackRequest(dataItem)"
              >
                <mat-icon>edit</mat-icon>
              </button>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column [width]="80" field="actioned" title="Actioned">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.actioned }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [width]="150"
            field="callbackReasonDesc"
            title="Reason"
            ><ng-template kendoGridCellTemplate let-dataItem>
              <span style="white-space: break-spaces">
                {{ dataItem.callbackReasonDesc }}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [width]="150"
            field="actionCategoryDesc"
            title="Action Category"
            ><ng-template kendoGridCellTemplate let-dataItem>
              <span style="white-space: break-spaces">
                {{ dataItem.actionCategoryDesc }}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [width]="200"
            field="additionalInfo"
            title="Additional Info"
            ><ng-template kendoGridCellTemplate let-dataItem>
              <span style="white-space: break-spaces">
                {{ dataItem.additionalInfo }}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [width]="200"
            field="salespersonNotes"
            title="Notes"
            ><ng-template kendoGridCellTemplate let-dataItem>
              <span style="white-space: break-spaces">
                {{ dataItem.salespersonNotes }}
              </span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            [width]="130"
            field="creationDate"
            title="Created At"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.creationDate | date : "MMM d, yyyy HH:mm" }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [width]="130"
            field="actionedDate"
            title="Actioned At"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.actionedDate | date : "MMM d, yyyy HH:mm" }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [width]="130"
            field="actionedUserDesc"
            title="Actioned By"
            ><ng-template kendoGridCellTemplate let-dataItem>
              <span style="white-space: break-spaces">
                {{ dataItem.actionedUserDesc }}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [width]="130"
            field="modifiedDate"
            title="Modified At"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.modifiedDate | date : "MMM d, yyyy HH:mm" }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [width]="130"
            field="modifiedUserDesc"
            title="Modified By"
            ><ng-template kendoGridCellTemplate let-dataItem>
              <span style="white-space: break-spaces">
                {{ dataItem.modifiedUserDesc }}
              </span>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </div>
    </mat-card-content>
    <mat-card-footer> </mat-card-footer>
  </mat-card>
</ng-template>

<!-- Survey Responses -->
<ng-template #surveysTemplate>
  <mat-card style="align-self: stretch; overflow-x: auto; overflow-y: hidden">
    <mat-card-content>
      <mat-card-subtitle>
        <div class="card-title-container">
          <div>Survey Responses</div>
          <div>
            <button
              [matTooltip]="'Refresh Details'"
              mat-icon-button
              (click)="refresh()"
            >
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </div>
      </mat-card-subtitle>
      <div style="width: 100%">
        <kendo-grid
          style="max-height: 250px"
          [kendoGridBinding]="salesOrder.surveys"
          [scrollable]="true"
          [resizable]="true"
          [reorderable]="true"
          [sortable]="true"
        >
          <kendo-grid-column [width]="35" title="" class="td-action">
            <ng-template
              kendoGridCellTemplate
              let-dataItem
              let-rowIndex="rowIndex"
            >
              <button
                *ngIf="dataItem.canModify"
                mat-icon-button
                (click)="editSurveyResponse(dataItem)"
              >
                <mat-icon>edit</mat-icon>
              </button>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column [width]="80" field="actioned" title="Actioned">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.actioned }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [width]="150"
            field="surveyDesc"
            title="Survey Desc."
            ><ng-template kendoGridCellTemplate let-dataItem>
              <span style="white-space: break-spaces">
                {{ dataItem.surveyDesc }}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column [width]="80" field="surveyVersion" title="Version"
            ><ng-template kendoGridCellTemplate let-dataItem>
              <span style="white-space: break-spaces">
                {{ dataItem.surveyVersion }}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [width]="150"
            field="actionCategoryDesc"
            title="Action Category"
            ><ng-template kendoGridCellTemplate let-dataItem>
              <span style="white-space: break-spaces">
                {{ dataItem.actionCategoryDesc }}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [width]="200"
            field="salespersonNotes"
            title="Notes"
            ><ng-template kendoGridCellTemplate let-dataItem>
              <span style="white-space: break-spaces">
                {{ dataItem.salespersonNotes }}
              </span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            [width]="130"
            field="creationDate"
            title="Created At"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.creationDate | date : "MMM d, yyyy HH:mm" }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [width]="130"
            field="actionedDate"
            title="Actioned At"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.actionedDate | date : "MMM d, yyyy HH:mm" }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [width]="130"
            field="actionedUserDesc"
            title="Actioned By"
            ><ng-template kendoGridCellTemplate let-dataItem>
              <span style="white-space: break-spaces">
                {{ dataItem.actionedUserDesc }}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [width]="130"
            field="modifiedDate"
            title="Modified At"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.modifiedDate | date : "MMM d, yyyy HH:mm" }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            [width]="130"
            field="modifiedUserDesc"
            title="Modified By"
            ><ng-template kendoGridCellTemplate let-dataItem>
              <span style="white-space: break-spaces">
                {{ dataItem.modifiedUserDesc }}
              </span>
            </ng-template>
          </kendo-grid-column>

          <div *kendoGridDetailTemplate="let dataItem">
            <div style="width: 100%">
              <kendo-grid
                class="no-header-row"
                style="max-height: 250px"
                [kendoGridBinding]="dataItem.surveyAnswers"
                [scrollable]="true"
                [resizable]="true"
                [reorderable]="true"
                [sortable]="true"
              >
                <kendo-grid-column
                  [width]="200"
                  field="question"
                  title="Question"
                  ><ng-template kendoGridCellTemplate let-dataItem2>
                    <span style="white-space: break-spaces">
                      {{ dataItem2.question }}
                    </span>
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [width]="200" field="answer" title="Answer"
                  ><ng-template kendoGridCellTemplate let-dataItem2>
                    <span style="white-space: break-spaces">
                      {{ dataItem2.answer }}
                    </span>
                  </ng-template>
                </kendo-grid-column>
              </kendo-grid>
            </div>
          </div>
        </kendo-grid>
      </div>
    </mat-card-content>
    <mat-card-footer> </mat-card-footer>
  </mat-card>
</ng-template>


<!-- tfgRewardsCampaignsSysproOrderTemplate -->
<ng-template #tfgRewardsCampaignsSysproOrderTemplate>
  <mat-card style="align-self: stretch; overflow-x: auto; overflow-y: hidden">
    <mat-card-content>
      <mat-card-subtitle>
        <div class="card-title-container">
          <div>TFG Rewards Campaigns - Used on Order</div>

          <div style="display: flex;">
            <div>
              <!-- <mat-slide-toggle
                [(ngModel)]="showAllTfgCampaigns"
                (change)="tfgCampaignToggleChange($event)"
              ></mat-slide-toggle> -->
            </div>
            <div>
              <button
                [matTooltip]="'Export TFG Rewards Detailed Breakdown'"
                mat-icon-button
                (click)="showRewardsLineBreakdown()"
              >
                <mat-icon>analytics</mat-icon>
              </button>
            </div>
            <div>
              <button
                [matTooltip]="'Refresh Details'"
                mat-icon-button
                (click)="refresh()"
              >
                <mat-icon>refresh</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </mat-card-subtitle>
      <div style="width: 100%">
        <app-pos-tfg-campaign-details [tfgCampaignDetails]="salesOrder.tfgCampaignDetails" [showCampaignTotals]="true"></app-pos-tfg-campaign-details>
      </div>
    </mat-card-content>
    <mat-card-footer> </mat-card-footer>
  </mat-card>
</ng-template>

<!-- tfgRewardsCampaignsQuoteTemplate -->
<ng-template #tfgRewardsCampaignsQuoteTemplate>
  <mat-card style="align-self: stretch; overflow-x: auto; overflow-y: hidden">
    <mat-card-content>
      <mat-card-subtitle>
        <div class="card-title-container">
          <div>{{showAllTfgCampaigns ? 'TFG Rewards Campaigns - All Available' : 'TFG Rewards Campaigns - Used on Order'}}</div>

          <div style="display: flex;">
            <div>
              <mat-slide-toggle
                [(ngModel)]="showAllTfgCampaigns"
                (change)="tfgCampaignToggleChange($event)"
              ></mat-slide-toggle>
            </div>
            <div>
              <button
                [matTooltip]="'Export TFG Rewards Detailed Breakdown'"
                mat-icon-button
                (click)="showRewardsLineBreakdown()"
              >
                <mat-icon>analytics</mat-icon>
              </button>
            </div>
            <div>
              <button
                [matTooltip]="'Refresh Details'"
                mat-icon-button
                (click)="refresh()"
              >
                <mat-icon>refresh</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </mat-card-subtitle>
      <div style="width: 100%">
        <app-pos-tfg-campaign-details [tfgCampaignDetails]="showAllTfgCampaigns ? salesOrder.tfgCampaignDetailsAll : salesOrder.tfgCampaignDetails" [showCampaignTotals]="!showAllTfgCampaigns"></app-pos-tfg-campaign-details>
      </div>
    </mat-card-content>
    <mat-card-footer> </mat-card-footer>
  </mat-card>
</ng-template>
